module.exports = __webpack_public_path__ + "img/menu_icon05.1c0768a5.png";